import { DependencyList, EffectCallback, useEffect } from 'react';

function useDebouncedEffect(
  effect: EffectCallback,
  delay: number,
  deps: DependencyList = [],
): void {
  useEffect(() => {
    let cleanup: ReturnType<EffectCallback>;
    const timeoutId = setTimeout(() => {
      cleanup = effect();
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]);
}

export default useDebouncedEffect;
